import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="privacy">
      <Header />

      <main className="privacy__main">
        {/* 面包屑导航 */}
        <div className="breadcrumb">
          <div className="breadcrumb__container">
            <Link to="/" onClick={toTop}>
              HOME
            </Link>
            <span className="breadcrumb__separator">»</span>
            <span className="breadcrumb__current">PRIVACY POLICY</span>
          </div>
        </div>

        <div className="privacy__container">
          <div className="privacy__content">
            {/* 页面标题 */}
            <section className="privacy__hero">
              <h1 className="privacy__title">PRIVACY POLICY</h1>
              <p className="privacy__subtitle">
                Your privacy is important to us. This policy explains how we
                collect, use, and protect your personal information.
              </p>
              <p className="privacy__updated">Last updated: January 2025</p>
            </section>

            {/* 隐私政策内容 */}
            <div className="privacy__sections">
              <section className="privacy__section">
                <h2 className="section__title">1. Information We Collect</h2>
                <div className="section__content">
                  <p className="section__text">
                    We collect information you provide directly to us, such as
                    when you create an account, make a purchase, contact us, or
                    sign up for our newsletter.
                  </p>

                  <h3 className="subsection__title">Personal Information:</h3>
                  <ul className="section__list">
                    <li>
                      Name and contact information (email, phone, address)
                    </li>
                    <li>
                      Payment information (credit card details, billing address)
                    </li>
                    <li>Account credentials (username, password)</li>
                    <li>Communication preferences and marketing consents</li>
                  </ul>

                  <h3 className="subsection__title">
                    Automatically Collected Information:
                  </h3>
                  <ul className="section__list">
                    <li>
                      Device information (IP address, browser type, operating
                      system)
                    </li>
                    <li>
                      Usage data (pages visited, time spent, click patterns)
                    </li>
                    <li>Cookies and similar tracking technologies</li>
                    <li>Location data (if you enable location services)</li>
                  </ul>
                </div>
              </section>

              <section className="privacy__section">
                <h2 className="section__title">
                  2. How We Use Your Information
                </h2>
                <div className="section__content">
                  <p className="section__text">
                    We use the information we collect to provide, maintain, and
                    improve our services, process transactions, and communicate
                    with you.
                  </p>

                  <h3 className="subsection__title">Primary Uses:</h3>
                  <ul className="section__list">
                    <li>Process and fulfill your orders</li>
                    <li>Provide customer support and respond to inquiries</li>
                    <li>Send order confirmations and shipping updates</li>
                    <li>Improve our website and services</li>
                    <li>Prevent fraud and ensure security</li>
                  </ul>

                  <h3 className="subsection__title">
                    Marketing Communications:
                  </h3>
                  <ul className="section__list">
                    <li>
                      Send promotional emails about new products and offers
                    </li>
                    <li>Provide personalized recommendations</li>
                    <li>Conduct surveys and market research</li>
                    <li>Send newsletters and updates (with your consent)</li>
                  </ul>
                </div>
              </section>

              <section className="privacy__section">
                <h2 className="section__title">
                  3. Information Sharing and Disclosure
                </h2>
                <div className="section__content">
                  <p className="section__text">
                    We do not sell, trade, or otherwise transfer your personal
                    information to third parties without your consent, except as
                    described in this policy.
                  </p>

                  <h3 className="subsection__title">
                    We May Share Information With:
                  </h3>
                  <ul className="section__list">
                    <li>
                      <strong>Service Providers:</strong> Payment processors,
                      shipping companies, email service providers
                    </li>
                    <li>
                      <strong>Legal Requirements:</strong> When required by law
                      or to protect our rights
                    </li>
                    <li>
                      <strong>Business Transfers:</strong> In connection with
                      mergers, acquisitions, or asset sales
                    </li>
                    <li>
                      <strong>Consent:</strong> When you have given explicit
                      permission
                    </li>
                  </ul>

                  <p className="section__text">
                    All third-party service providers are contractually
                    obligated to keep your information confidential and use it
                    only for the purposes we specify.
                  </p>
                </div>
              </section>

              <section className="privacy__section">
                <h2 className="section__title">4. Data Security</h2>
                <div className="section__content">
                  <p className="section__text">
                    We implement appropriate technical and organizational
                    measures to protect your personal information against
                    unauthorized access, alteration, disclosure, or destruction.
                  </p>

                  <h3 className="subsection__title">
                    Security Measures Include:
                  </h3>
                  <ul className="section__list">
                    <li>SSL encryption for data transmission</li>
                    <li>Secure payment processing systems</li>
                    <li>Regular security audits and updates</li>
                    <li>Access controls and employee training</li>
                    <li>Data backup and recovery procedures</li>
                  </ul>

                  <p className="section__text">
                    However, no method of transmission over the internet or
                    electronic storage is 100% secure. While we strive to
                    protect your information, we cannot guarantee absolute
                    security.
                  </p>
                </div>
              </section>

              <section className="privacy__section">
                <h2 className="section__title">
                  5. Cookies and Tracking Technologies
                </h2>
                <div className="section__content">
                  <p className="section__text">
                    We use cookies and similar technologies to enhance your
                    browsing experience, analyze site traffic, and personalize
                    content.
                  </p>

                  <h3 className="subsection__title">
                    Types of Cookies We Use:
                  </h3>
                  <ul className="section__list">
                    <li>
                      <strong>Essential Cookies:</strong> Required for basic
                      site functionality
                    </li>
                    <li>
                      <strong>Performance Cookies:</strong> Help us understand
                      how visitors use our site
                    </li>
                    <li>
                      <strong>Functional Cookies:</strong> Remember your
                      preferences and settings
                    </li>
                    <li>
                      <strong>Marketing Cookies:</strong> Used to deliver
                      relevant advertisements
                    </li>
                  </ul>

                  <p className="section__text">
                    You can control cookies through your browser settings.
                    However, disabling certain cookies may affect site
                    functionality.
                  </p>
                </div>
              </section>

              <section className="privacy__section">
                <h2 className="section__title">6. Your Rights and Choices</h2>
                <div className="section__content">
                  <p className="section__text">
                    You have certain rights regarding your personal information,
                    subject to applicable laws.
                  </p>

                  <h3 className="subsection__title">Your Rights Include:</h3>
                  <ul className="section__list">
                    <li>
                      <strong>Access:</strong> Request a copy of your personal
                      information
                    </li>
                    <li>
                      <strong>Correction:</strong> Update or correct inaccurate
                      information
                    </li>
                    <li>
                      <strong>Deletion:</strong> Request deletion of your
                      personal information
                    </li>
                    <li>
                      <strong>Portability:</strong> Receive your data in a
                      portable format
                    </li>
                    <li>
                      <strong>Opt-out:</strong> Unsubscribe from marketing
                      communications
                    </li>
                  </ul>

                  <p className="section__text">
                    To exercise these rights, please contact us using the
                    information provided at the end of this policy. We will
                    respond to your request within a reasonable timeframe.
                  </p>
                </div>
              </section>

              <section className="privacy__section">
                <h2 className="section__title">7. Data Retention</h2>
                <div className="section__content">
                  <p className="section__text">
                    We retain your personal information for as long as necessary
                    to fulfill the purposes outlined in this policy, unless a
                    longer retention period is required by law.
                  </p>

                  <h3 className="subsection__title">Retention Periods:</h3>
                  <ul className="section__list">
                    <li>
                      <strong>Account Information:</strong> Until account
                      deletion or 3 years of inactivity
                    </li>
                    <li>
                      <strong>Transaction Records:</strong> 7 years for tax and
                      legal compliance
                    </li>
                    <li>
                      <strong>Marketing Data:</strong> Until you opt-out or 2
                      years of inactivity
                    </li>
                    <li>
                      <strong>Support Communications:</strong> 3 years from last
                      contact
                    </li>
                  </ul>
                </div>
              </section>

              <section className="privacy__section">
                <h2 className="section__title">
                  8. International Data Transfers
                </h2>
                <div className="section__content">
                  <p className="section__text">
                    Your information may be transferred to and processed in
                    countries other than your country of residence. We ensure
                    appropriate safeguards are in place to protect your
                    information during such transfers.
                  </p>
                  <p className="section__text">
                    For transfers outside Australia, we use standard contractual
                    clauses or other legally recognized mechanisms to ensure
                    your data receives adequate protection.
                  </p>
                </div>
              </section>

              <section className="privacy__section">
                <h2 className="section__title">9. Children's Privacy</h2>
                <div className="section__content">
                  <p className="section__text">
                    Our services are not intended for children under 13 years of
                    age. We do not knowingly collect personal information from
                    children under 13. If we become aware that we have collected
                    such information, we will take steps to delete it promptly.
                  </p>
                  <p className="section__text">
                    If you are a parent or guardian and believe your child has
                    provided us with personal information, please contact us
                    immediately.
                  </p>
                </div>
              </section>

              <section className="privacy__section">
                <h2 className="section__title">10. Changes to This Policy</h2>
                <div className="section__content">
                  <p className="section__text">
                    We may update this Privacy Policy from time to time to
                    reflect changes in our practices or applicable laws. We will
                    notify you of any material changes by posting the updated
                    policy on our website and updating the "Last updated" date.
                  </p>
                  <p className="section__text">
                    Your continued use of our services after any changes
                    constitutes acceptance of the updated policy.
                  </p>
                </div>
              </section>

              <section className="privacy__section">
                <h2 className="section__title">11. Contact Information</h2>
                <div className="section__content">
                  <p className="section__text">
                    If you have questions about this Privacy Policy or our data
                    practices, please contact us:
                  </p>
                  <div className="contact__details">
                    <p>
                      <strong>Emeline Publications Australia</strong>
                    </p>
                    <p>6107 Katherine Rd, Rex, Georgia 30273, United States</p>
                    <p>
                      <strong>Business Hours:</strong> Monday - Friday, 9:30am
                      to 4:00pm AEST
                    </p>
                  </div>
                </div>
              </section>
            </div>

            {/* 相关链接 */}
            <section className="privacy__links">
              <h2 className="section__title">Related Policies</h2>
              <div className="policy__links">
                <Link to="/terms" onClick={toTop} className="policy__link">
                  Terms & Conditions
                </Link>
                <Link to="/returns" onClick={toTop} className="policy__link">
                  Returns Policy
                </Link>
                <Link to="/delivery" onClick={toTop} className="policy__link">
                  Delivery Information
                </Link>
                <Link to="/contact" onClick={toTop} className="policy__link">
                  Contact Us
                </Link>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Privacy;
